/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class WorkflowService {

  constructor(private http: HttpClient) { }

  getWorkflows(): Observable<any> {
    return this.http
      .get(
        `/api/v1/workflows`
      );
  }

  getWorkflow(workflowId: string): Observable<any> {
    return this.http
      .get(
        `/api/v1/workflow/${workflowId}`
      );
  }

  setEnabled(workflowId: string, enabled: boolean): Observable<any> {
    return this.http
      .put(
        `/api/v1/workflows/${workflowId}`,
        { enabled: enabled}
      );
  }

  setDeleted(workflowId: string) {
    return this.http
      .put(
        `/api/v1/workflows/${workflowId}`,
        { enabled: false, deleted: true}
      );
  }

  savePartial(workflowId: string, update: any): Observable<any> {
    return this.http
      .put(
        `/api/v1/workflows/${workflowId}`,
        update
      );
  }

  saveNew(workflow: any): Observable<any> {
    return this.http
      .post(
        `/api/v1/workflow`,
        workflow
      );
  }
}



// WEBPACK FOOTER //
// ./client/app/services/workflow.service.ts